import { parseCamelCase } from 'utilities'

export const parseToLabel = (str: string) => {
  if (!str) return ''
  const arr: string[] = parseCamelCase(str).split(' ')
  return arr
    .map((word, index) => index === 0 ? word : word.toLowerCase())
    .join(' ')
}

export const reducer = (sum: number, value: number) => {
  return sum + value
}
